import { Link, useMatch } from "react-router-dom";

export default function Banner() {

 const onHomePage = useMatch("/");

  return (
    <div className="relative mt-20 md:mt-24">
      <div
        className={`bg-cover bg-center ${onHomePage ? "h-[32rem]" : "h-2 bg-top"}`}
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/img/banner.jpg"})` }}
      />
      {onHomePage &&
        <>
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />
          <div className="absolute inset-0 flex items-end pb-16">
            <div className="container mx-auto">
              <div className="max-w-2xl">
                <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                  Connecting Europe and Africa through sustainable investments
                </h1>
                <p className="mt-4 text-lg text-white/75 max-w-xl">
                  We are an ecosystem of stakeholders promoting and facilitating sustainable investments in Africa
                </p>
                <Link to="/about-us" className="inline-block mt-8 rounded-full bg-bahyellow text-black font-semibold px-7 py-3 hover:brightness-95 transition-all">
                  Learn more
                </Link>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}
